import * as React from 'react';
import { HTMLAttributes } from 'react';
import * as cs from 'classnames';
import { AssetProps } from './Asset';
import './Pdf.css';

export interface PdfProps extends AssetProps {
}

export const Pdf: React.FC<PdfProps & HTMLAttributes<HTMLDivElement>> =
    ({
         url,
         title = '',
         description = '',
         className
     }) => (
        <span className={cs('asset', 'asset-pdf', className)}>
            <a className="asset-pdf__link" href={url} title={description} target="_blank">{title}</a>
         </span>
    );


// WEBPACK FOOTER //
// ./src/asset/Pdf.tsx